import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useEntitlements } from '@/hooks/useEntitlements';
import { landingPath } from '@/lib/landing';

/**
 * `/` (JSS#1155): send the user to their role's surface (`landingPath`).
 *
 * A customer's role is granted per org, so the token alone under-reports it
 * (#847). Wait for the BFF's /api/auth/me (`meStatus`): `ready` lands by the
 * org role, `error` by the token's roles. A superuser always lands on Home,
 * so there is nothing to wait for.
 *
 * A role's surface the acting org doesn't have lands on Home (#1160), so the
 * acting org's entitlements are waited on too. A failed read lands as before.
 */
export default function RoleLanding() {
  const { user, meStatus } = useAuth();
  const { entitlements, isLoading } = useEntitlements();
  if (user?.role !== 'superuser' && (meStatus === 'pending' || isLoading)) {
    return (
      <div className="flex items-center justify-center py-24" role="status" aria-label="Loading">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-jeket-gold" />
      </div>
    );
  }
  return <Navigate to={landingPath(user, entitlements?.surfaces)} replace />;
}
